export type PwaInstallStepIcon = 'addToHomeScreen' | 'more' | 'share';

export interface PwaInstallStep {
  icon: PwaInstallStepIcon;
  label: string;
}

// Share and Add to Home Screen are the glyphs Safari draws on those buttons
// (paths from `react-ios-pwa-prompt`, MIT), so the step points at what the
// visitor sees. "•••" is Safari 26's button beside the address bar.
const ICONS: Record<PwaInstallStepIcon, JSX.Element> = {
  addToHomeScreen: (
    <svg viewBox="0 0 18.3398 17.9785">
      <path d="M3.06641 17.9785L14.9121 17.9785C16.9629 17.9785 17.9785 16.9727 17.9785 14.9609L17.9785 3.02734C17.9785 1.01562 16.9629 0 14.9121 0L3.06641 0C1.02539 0 0 1.01562 0 3.02734L0 14.9609C0 16.9727 1.02539 17.9785 3.06641 17.9785ZM3.08594 16.4062C2.10938 16.4062 1.57227 15.8887 1.57227 14.873L1.57227 3.11523C1.57227 2.09961 2.10938 1.57227 3.08594 1.57227L14.8926 1.57227C15.8594 1.57227 16.4062 2.09961 16.4062 3.11523L16.4062 14.873C16.4062 15.8887 15.8594 16.4062 14.8926 16.4062Z" />
      <path d="M4.47266 8.98438C4.47266 9.46289 4.80469 9.78516 5.30273 9.78516L8.17383 9.78516L8.17383 12.666C8.17383 13.1543 8.50586 13.4961 8.98438 13.4961C9.47266 13.4961 9.81445 13.1641 9.81445 12.666L9.81445 9.78516L12.6953 9.78516C13.1836 9.78516 13.5254 9.46289 13.5254 8.98438C13.5254 8.49609 13.1836 8.1543 12.6953 8.1543L9.81445 8.1543L9.81445 5.2832C9.81445 4.78516 9.47266 4.44336 8.98438 4.44336C8.50586 4.44336 8.17383 4.78516 8.17383 5.2832L8.17383 8.1543L5.30273 8.1543C4.80469 8.1543 4.47266 8.49609 4.47266 8.98438Z" />
    </svg>
  ),
  more: (
    <svg viewBox="0 0 24 24">
      <circle cx="4" cy="12" r="2.25" />
      <circle cx="12" cy="12" r="2.25" />
      <circle cx="20" cy="12" r="2.25" />
    </svg>
  ),
  share: (
    <svg viewBox="0 0 17.6953 26.0059">
      <path d="M17.334 10.8105L17.334 20.4395C17.334 22.4512 16.3086 23.4668 14.2676 23.4668L3.06641 23.4668C1.02539 23.4668 0 22.4609 0 20.4395L0 10.8105C0 8.78906 1.02539 7.7832 3.06641 7.7832L6.05469 7.7832L6.05469 9.35547L3.08594 9.35547C2.10938 9.35547 1.57227 9.87305 1.57227 10.8887L1.57227 20.3613C1.57227 21.377 2.10938 21.8945 3.08594 21.8945L14.2383 21.8945C15.2051 21.8945 15.7617 21.377 15.7617 20.3613L15.7617 10.8887C15.7617 9.87305 15.2051 9.35547 14.2383 9.35547L11.2695 9.35547L11.2695 7.7832L14.2676 7.7832C16.3086 7.7832 17.334 8.79883 17.334 10.8105Z" />
      <path d="M8.66211 15.8203C9.08203 15.8203 9.44336 15.4785 9.44336 15.0684L9.44336 5.13672L9.38477 3.68164L9.93164 4.25781L11.4355 5.86914C11.5723 6.02539 11.7773 6.10352 11.9629 6.10352C12.373 6.10352 12.6758 5.81055 12.6758 5.41992C12.6758 5.20508 12.5977 5.04883 12.4512 4.90234L9.22852 1.79688C9.0332 1.60156 8.86719 1.54297 8.66211 1.54297C8.4668 1.54297 8.30078 1.60156 8.0957 1.79688L4.88281 4.90234C4.73633 5.04883 4.64844 5.20508 4.64844 5.41992C4.64844 5.81055 4.94141 6.10352 5.35156 6.10352C5.53711 6.10352 5.75195 6.02539 5.88867 5.86914L7.40234 4.25781L7.94922 3.68164L7.89062 5.13672L7.89062 15.0684C7.89062 15.4785 8.24219 15.8203 8.66211 15.8203Z" />
    </svg>
  ),
};

export interface PwaInstallStepsProps {
  steps: PwaInstallStep[];
}

/** The iPhone's way home: there is no install dialog to open, only steps. */
const PwaInstallSteps = ({ steps }: PwaInstallStepsProps) => (
  <ol className="Mfw-PwaInstallSheet-steps">
    {steps.map((step) => (
      <li className="Mfw-PwaInstallSheet-step" key={step.icon}>
        <span aria-hidden className="Mfw-PwaInstallSheet-stepIcon">
          {ICONS[step.icon]}
        </span>
        <span>{step.label}</span>
      </li>
    ))}
  </ol>
);
export default PwaInstallSteps;
